import { DefaultValues, useForm, UseFormOptions } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers'
import { DEFAULT_RADIUS } from '../constants'
import { SavedLaneSchema, TSavedLaneSchema } from '../schema/SavedLaneSchema'
import { IDateTypes, IEquipmentTypes, IRateTypes, IUseSavedLaneFormContext } from '../types'

export const getDefaultValues = <TSavedLaneSchema>(values: DefaultValues<TSavedLaneSchema>) => {
  return SavedLaneSchema.cast({
    lane: {
      pickup: null,
      pickupRadius: DEFAULT_RADIUS,
      dropoff: null,
      dropoffRadius: DEFAULT_RADIUS,
    },
    dateType: IDateTypes.anyDay,
    date: null,
    equipment: IEquipmentTypes.anyEquipment,
    rateType: IRateTypes.ratePerMile,
    receiveNotifications: true,
    ...values,
  })
}

export interface IUseSavedLaneFormProps
  extends Omit<UseFormOptions<TSavedLaneSchema, IUseSavedLaneFormContext>, 'resolver'> {}

export const useSavedLaneForm = ({
  defaultValues = {},
  context,
  ...props
}: IUseSavedLaneFormProps) => {
  return useForm<TSavedLaneSchema, IUseSavedLaneFormContext>({
    context,
    resolver: yupResolver(SavedLaneSchema),
    defaultValues: getDefaultValues(defaultValues),
    ...props,
  })
}
